import {useConfigurationsContext} from '../contexts/configuration-context';
import {useTariffsConfigurationsContext} from '../contexts/tariffs-configuration-context';

type AppDataContentFlag =
  | 'hideVehicleImage'
  | 'hideConfigureButton'
  | 'isContentLayer';
type TariffsAppDataContentFlag = 'isContentLayer';

export const useGetAppDataContentFlag = (flag: AppDataContentFlag): boolean => {
  const {appDataContent} = useConfigurationsContext();
  return appDataContent?.[flag] === 'true';
};

export const useGetTariffsAppDataContentFlag = (
  flag: TariffsAppDataContentFlag
): boolean => {
  const {appDataContent} = useTariffsConfigurationsContext();
  return appDataContent?.[flag] === 'true';
};
